<button type="button" class="btn btn-sm btn-default btn-block btn-primary" (click)="openMatrixModal(product)">
  {{ 'ORDER' | translate | uppercase }}
  <i class="fa ml-2 fas fa-th"></i>
</button>
